var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.008,
    height: 2.5,
    viewBox: "0 0 30.008 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-logout",
    d: "M-12.187.5A2.813,2.813,0,0,1-15-2.312V-19.187A2.813,2.813,0,0,1-12.187-22h7.734a.705.705,0,0,1,.7.7v.469a.705.705,0,0,1-.7.7h-7.734a.94.94,0,0,0-.937.938V-2.312a.94.94,0,0,0,.938.938h7.734a.705.705,0,0,1,.7.7V-.2a.705.705,0,0,1-.7.7ZM4.16-.643l-.416-.416a.7.7,0,0,1,0-1l7.734-7.7h-16.4a.705.705,0,0,1-.7-.7v-.586a.705.705,0,0,1,.7-.7h16.4l-7.729-7.7a.7.7,0,0,1,0-1l.416-.416a.7.7,0,0,1,1,0L14.8-11.248a.7.7,0,0,1,0,1L5.156-.643A.7.7,0,0,1,4.16-.643Z",
    transform: "translate(15.008 0.5) rotate(180)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogout);
export default __webpack_public_path__ + "static/media/ico-logout.baff282ce367436e8013e779eb29fc82.svg";
export { ForwardRef as ReactComponent };